import { IUserNotesTag } from "@sagecentral/core-ui";
import { MentionFeedObjectItem, FeedCallback } from '@sagecentral/ckeditor';
import { useCurrentUser, useCentralApi } from "hooks/shared";

const useSearchUsers: () => FeedCallback | null = () => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const fetchUsers: FeedCallback = async (searchText: string) => {
        if (!user) {
            console.warn('no user');
            return [];
        }
        searchText = encodeURIComponent(searchText);

        const query = `?search=${searchText}&&limit=10`;

        try {
            const url = `/api/v3/accounts/searchuser${query}`;            
            const resp = await fetcher(url);
            if (!resp.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await resp.json() as IUserNotesTag[];
            return data.map<MentionFeedObjectItem>((user: IUserNotesTag) => ({
                id: `@${user.userId}`,
                text: user.displayName
            }));
        } catch (err) {
            console.error("Error fetching users:", err);
            throw err;
        }
    };

    return user ? fetchUsers : null;
};

export default useSearchUsers;